module.exports = __webpack_public_path__ + "static/media/mute.7c69c998.svg";